export class PlazoPeriodoCamViewModel {
    constructor() {}

    public Id: number;
    public IdPeriodo: number;
    public Ordinal: string;
    public IdCampaniaDescripcion: string;
    public DescripcionPeriodo: string;
    public FechaInicioPeriodo: Date;
    public FechaFinPeriodo: Date;
    public PresentarSolicitudesFueraPeriodo: boolean;
    public FechaInicioPresentacion: Date | null;
    public FechaFinPresentacion: Date | null;
    public FechaInicioExportacionParcela: Date | null;
    public FechaInicioExportacionConfeccion: Date | null;
    public FechaInicioExportacionInvernadero: Date | null;
    public FechaInicioExportacionEmpDeshidratadoras: Date | null;
    public PresentacionAutoParcela: boolean;
    public PresentacionAutoAlmacenes: boolean;
    public PresentacionAutoInvernadero: boolean;
    public PresentacionAutoEmpDeshidratadoras: boolean;
    public ObligatoriaPrimeraInspeccion: boolean;
    public Parcela: boolean;
    public Confeccion: boolean;
    public Invernadero: boolean;
    public EmpresaDeshidratadora: boolean;
    public HabilitadaExportacionParcelas: boolean;
    public HabilitadaExportacionAlmacenes: boolean;
    public HabilitadaExportacionInvernaderos: boolean;
    public HabilitadaExportacionEmpDeshidratadoras: boolean;
}

export class ListaPlazosPeriodoCamViewModel {
    public IdCampaniaDescripcion: string;
    public DescripcionPeriodo: string;
    public PeriodoFechaInicio?: Date;
    public PeriodoFechaFin?: Date;
    public Dextrio?: number;
    public PlazoPeriodoCollection: PlazoPeriodoCamViewModel[];
}

export class DatosPeriodoViewModel {
    public IdPeriodo: number;
    public IdCampaniaDescripcion: string;
    public DescripcionPeriodo: string;
    public FechaInicioPeriodo: Date;
    public FechaFinPeriodo: Date;
    public PresentarSolicitudesFueraPeriodo: boolean;
    public Parcela: boolean;
    public Confeccion: boolean;
    public Invernadero: boolean;
    public EmpresaDeshidratadora: boolean;
}
